import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SidebarRoute } from 'src/app/material-module/custom-sidebar/custom-sidebar.component';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';
import { CollegamentoService } from '../../services/collegamento.service';
import { EstensioneService } from 'src/app/services/estensione.service';
import { LavoriInCorsoService } from 'src/app/services/statistiche/lavori-in-corso.service';
import { IncaricoService } from 'src/app/services/incarico.service';
import { WorkflowService } from 'src/app/services/workflow.service';
import { QuadroRiassuntivoService } from 'src/app/services/statistiche/quadro-riassuntivo.service';
import { DatoQuadroRiassuntivoSingoloMese, QuadroRiassuntivoGruppo } from '../../services/statistiche/quadro-riassuntivo.service';
import { StatisticheBaseAnnuaService } from 'src/app/services/statistiche/statistiche-base-annua.service';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { Incarico } from '../../models/incarico';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Moment } from 'moment';
import * as moment from "moment";


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  @ViewChild('incarichiUrgentiModal') incarichiUrgentiModal!: TemplateRef<any>;

  user: User;
  map_enabled: boolean;
  incarichiInCorsoCount: number = 0;
  IncarichiInAttesaSopralluogoCount: number = 0;
  incarichiUrgenti: Incarico[];
  loggedUser: number;
  workflow: any;

  stats: any;

  // Statistiche anno corrente
  statsAnno: {
    ricevuti: number;
    evasi: number;
    da_evadere: number;
    riparazioni: number;
    videoperizie: number;
  };

  private dialogRef: MatDialogRef<any>;

  constructor(
    private collegamentiService: CollegamentoService,
    private authService: AuthService,
    private estensioneService: EstensioneService,
    private incaricoService: IncaricoService,
    private workflowService: WorkflowService,
    private quadroRiassuntivoService: QuadroRiassuntivoService,
    private lavoriInCorsoService: LavoriInCorsoService,
    private statisticheBaseAnnuaService: StatisticheBaseAnnuaService,
    private dialog: MatDialog,
  ) { }

  async ngOnInit(): Promise<void> {
    let sidebarPromise = this.collegamentiService.getAll()

    this.loggedUser = await this.authService.loggedInUser.getValue().studio_id;

    this.sidebarRoutes$ = await from(sidebarPromise).pipe(
      map(collegamenti => collegamenti.sort((a, b) => a.ordinale - b.ordinale).map(collegamento => new SidebarRoute(collegamento?.nome, collegamento?.url, collegamento?.compagnia)))
    );

    this.user = this.authService.getLoggedInUserFromLocalStorage()

    this.incarichiInCorsoCount = (await this.lavoriInCorsoService.getLavoriInCorso()).length;
    this.IncarichiInAttesaSopralluogoCount = (await this.lavoriInCorsoService.getLavoriInCorso(true)).length;
    this.incarichiUrgenti = await this.incaricoService.getIncarichiUrgenti();

    if (this.incarichiUrgenti && this.incarichiUrgenti.length > 0) {
      setTimeout(() => {
        this.openIncarichiUrgentiModal();
      }, 1000);
    }

    this.loadStats();
    this.loadStatsAnnoCorrente();

    try {
      const estensioneMappa = await this.estensioneService.bySlug("Mappa Sopralluoghi");
      this.map_enabled = !!estensioneMappa?.enabled;
    } catch (error) {
      this.map_enabled = false;
    }
  }

  async loadStatsAnnoCorrente() {
    this.statsAnno = await this.statisticheBaseAnnuaService.getRicevutiEvasiDaEvadere();
  }

  async loadStats() {
    this.stats = {};

    this.stats.inLavorazione = await this.incaricoService.getAll(
      [],
      {
        search: {
          in_lavorazione: 1,
          escludere_nuovi_generali: 1
        }
      }
    ).then(res => {
      this.stats.attesaSopralluogo = res?.filter(value => value?.data_sopralluogo == null)?.length;

      return res?.length;
    });

    this.stats.daEvadere = await this.workflowService.getWorkflowDaEvadereCount().toPromise();

    this.stats.daControllare = await this.workflowService.getWorkflowDaControllareCount().toPromise();

    let res = await this.quadroRiassuntivoService.getQuadroRiassuntivoData({ anno: new Date().getFullYear() });

    this.getRatioAC(res);
  }

  getRatioAC({ dati }) {
    var assegnati = 0;
    var in_lavorazione = 0;

    for (const key in dati) {
      for (const value in dati[key]) {
        assegnati += dati[key][value]?.assegnati || 0;
        in_lavorazione += dati[key][value]?.in_lavorazione || 0;
      }
    }

    this.stats.AC = assegnati > 0 ? ((assegnati - in_lavorazione) / assegnati * 100).toFixed(1) : 0;
  }

  getPercentageColor(percentage: number): string {
    const value = Number(percentage);
    if (isNaN(value)) {
      return '#3f51b5';
    }
    
    const normalizedValue = Math.max(0, Math.min(100, value));
    
    let r, g, b = 0;
    if (normalizedValue <= 50) {
      r = Math.round(200 + (normalizedValue / 50) * 55);
      g = Math.round((normalizedValue / 50) * 200);
    } else {
      r = Math.round(255 - ((normalizedValue - 50) / 50 * 255));
      g = Math.round(200 - ((normalizedValue - 50) / 50 * 70)); 
      b = 0;
    }
    
    return `rgb(${r}, ${g}, ${b})`;
  }

  sidebarRoutes$: Observable<SidebarRoute[]>

  getUltimaInterlocutoria(incarico: Incarico): Moment | null {
    if (incarico.terza_interlocutoria) {
      return moment(incarico.terza_interlocutoria);
    } else if (incarico.seconda_interlocutoria) {
      return moment(incarico.seconda_interlocutoria);
    } else if (incarico.prima_interlocutoria) {
      return moment(incarico.prima_interlocutoria);
    }
    return null;
  }

  openIncarichiUrgentiModal(): void {
    this.dialogRef = this.dialog.open(this.incarichiUrgentiModal, {
      width: '90%',
      maxWidth: '1200px',
      maxHeight: '80vh',
      disableClose: false,
      panelClass: 'no-padding-dialog'
    });
  }

  closeModal(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
